import React from "react"

function About(){
    const activeTab = (tab) => {
        const tabLinks = document.querySelectorAll(".tab-links");
        const tabContents = document.querySelectorAll(".tab-contents");

        tabLinks.forEach((link) => {
            link.classList.remove("active-link");
        });

        tabContents.forEach((content) => {
            content.classList.remove("active-tab");
        });

        document.querySelector(`#${tab}`).classList.add("active-tab");
        document.querySelector(`#${tab}-link`).classList.add("active-link");
    };



 
    return(
    
        
     <div id="about">

          <div class="container bd-grid">
                    <div class="row">

    
                           <div class="about-col-1">
                              
                           <div class="tab-titles">
                                    <p class="tab-links active-link" 
                                    id="skills-link"
                                    onClick={() => activeTab("skills")}
                                    >Skills</p>
                                    <p class="tab-links" 
                                    id="experience-link"
                                    onClick={() => activeTab("experience")}
                                    >Experience</p>
                                    <p class="tab-links" 
                                    id="education-link"
                                    onClick={() => activeTab("education")}
                                    >Education</p>
                                  </div>

                                  <div class="tab-contents active-tab" id="skills">
                                   <ul>
                                        <li> -> HTML5</li>
                                        <li> -> CSS3</li>
                                        <li> -> JavaScript</li>
                                        <li> -> TypeScript</li>
                                        <li> -> React Js</li>
                                        <li> -> Node Js</li>
                                        <li> -> Ruby on Rails</li>
                                        <li> -> Postgress</li>
                                       
                                   </ul>

                                    </div>
                                    
                                    <div class="tab-contents" id="experience">
                                    <ul>
                                        <li>
                                        <h5>Freelancer</h5>
                                            <p>
                                              Front End Developer
                                            </p>
                                        </li>
                                        <li>
                                            <h5>Graphic Designer</h5>
                                            <p>Digital Marketer</p>
                                        </li>
                                       
                                        </ul>
                                    </div>

                                    <div class="tab-contents" id="education">
                                    <ul>
                                        <li>
                                        <h5>Moringa School</h5>
                                            <p> Sofware Engeneering</p>
                                            </li>
                                        <li>
                                           <h5> Nairobits School of Technology</h5>
                                            <p> Digital Marketing and Graphic Design</p>
                                            </li>

                                        </ul>
                                    </div>



                            </div>
                                          <div class="about-col-2">
                                        
                                          <h2 class="section-title">About Me</h2>
                                           <p class="aboutme">
                                           Experienced Software Engineer with expertise in React.js, JavaScript, HTML, CSS, Ruby, and Ruby on Rails. Skilled in styling frameworks like Tailwind and Bootstrap, with a strong foundation in Graphic Design. Detail-oriented and committed to excellence, I bring a collaborative approach and proficiency in TypeScript for impactful contributions to software development.
                                             </p>
            
                                        </div>

                                    </div>
                               </div>
                     </div>
        
    )
}

export default About